@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (value$ | async; as value) {
        <dd class="sh-description-list__details">
            <med-thesaurus-concept [conceptReference]="value" [thesaurusFieldDefinition]="profileField.FieldDefinition"></med-thesaurus-concept>
        </dd>
    } @else {
        @if (suggestion$ | async; as suggestion) {
            <dd class="sh-description-list__details">
                <i class="sh-icon-label" style="margin-left: 0">
                    <span>{{ suggestion }}</span>
                    <span class="sh-icon-label__icon -sh-superscript" style="margin-left: 2px" [title]="'thesaurus.suggestion-not-approved' | translate">
                        <svg sh-icon [size]="'small'" aria-hidden="true" [name]="'info'"></svg>
                    </span>
                </i>
            </dd>
        } @else {
            <dd class="sh-description-list__details">-</dd>
        }
    }
}
